export default __webpack_public_path__ + "static/media/date-field-trigger-toolbox.a75671ce.svg";